import { MPCIOrderModalPayload } from "../typings/iOrderModalPayload";
import { MPCLocalStorageService } from "../../local-storage-service";
import { MPCNotificationService } from "../../PCF/notification-service";
import { MPCDeviceDetectionHelper } from "../../helpers/deviceDetectionHelper";

export module MPCColumnHeader {
    import OrderModalPayload = MPCIOrderModalPayload.IOrderModalPayload;
    import ProductComparisonModelManager = MPCLocalStorageService.ProductComparisonModelManager;
    import NotificationService = MPCNotificationService.NotificationService;
    import DeviceDetectionHelper = MPCDeviceDetectionHelper.DeviceDetectionHelper;

    export class ColumnHeader {
        private header: HTMLElement;
        private grid: HTMLElement;
        private recycleBtn: HTMLElement;
        private orderModalBtn: HTMLElement;
        private emptyHeaderContainer: HTMLElement;
        private productComparisonModelManager: ProductComparisonModelManager;
        private notificationService: NotificationService;
        private deviceDetectionHelper: DeviceDetectionHelper;
        private categoryName: string;
        private navigationOrder: number;

        public init(header: HTMLElement, grid: HTMLElement, lastColumn: boolean, firstColumn: boolean): void {
            this.header = header;
            this.grid = grid;
            this.productComparisonModelManager = ProductComparisonModelManager.instance;
            this.notificationService = NotificationService.instance;
            this.deviceDetectionHelper = DeviceDetectionHelper.instance;
            this.categoryName = this.grid.getAttribute('data-pcp-navigation-key');
            this.navigationOrder = Number(this.grid.getAttribute('data-navigation-order'));

            if(firstColumn)
                this.header.classList.add('first-column');

            if(lastColumn)
                this.header.classList.add('last-column');

            this.handleEmptyContainer = this.handleEmptyContainer.bind(this);

            this.registerEvents();
        }

        private registerEvents(): void {
            const imageContainer = this.header.querySelector('.image-container');
            this.recycleBtn = this.header.querySelector('.mpc-recycle');
            this.orderModalBtn = this.header.querySelector('.order-modal-button');
            this.emptyHeaderContainer = this.header.querySelector('.empty-header');
            
            if (imageContainer) {
                imageContainer.addEventListener('keydown', (event: any) => {
                    // prevent page jump down on Space btn., click
                    if (event.code === 'Space')
                        event.preventDefault(); 
                });
            }

            if (this.recycleBtn) {
                this.recycleBtn.addEventListener('click', () => { this.handleRecycleBtnClick(); });

                this.recycleBtn.addEventListener('keydown', (event: any) => {
                    // prevent page jump down on Space btn., click
                    if (event.code === 'Space')
                        event.preventDefault(); 
                });
            }

            if (this.orderModalBtn) {
                this.orderModalBtn.addEventListener('click', () => { this.setupOrderModalEvent(); });

                this.orderModalBtn.addEventListener('keydown', (event: any) => {
                    // prevent page jump down on Space btn., click
                    if (event.code === 'Space')
                        event.preventDefault();
                });
            }

            if (this.emptyHeaderContainer) {
                this.emptyHeaderContainer.addEventListener('click', this.handleEmptyContainer);
            }
        }

        private setupOrderModalEvent() {
            const splittedSavKey: string[] = this.header.getAttribute('data-savKey').split('-');

            const orderModalPayload: OrderModalPayload = {
                salesArticleNo: splittedSavKey[0],
                masterArticleNo: parseInt(this.header.getAttribute('data-masterArticle')),
                colorCode: splittedSavKey.length >= 2 ? parseInt(splittedSavKey[1]) : null,
                sizeCode: splittedSavKey.length >= 3 ? parseInt(splittedSavKey[2]) : null,
                itemOrigin: 'productcomparison',
            };

            if (window.shell)
                window.shell.publishTo('ESPP.OrderModal.Open', orderModalPayload);
        }

        private handleRecycleBtnClick(): void {
            // collect all column rows and clear them:
            const columnId: string = this.header.getAttribute('data-savKey');

            // prepare new url:
            let currentUrl: string = window.location.href;
            const urlParam: string = '&savKeys=' + columnId;
            currentUrl = currentUrl.replace(urlParam, '');

            // clear local storage:
            this.productComparisonModelManager.removeProduct(this.categoryName, columnId);

            // look for existing savKeys, if it was the last one update active tab in flyout.
            const savKeysExists: number = currentUrl.indexOf('&savKeys');

            // store this tab in local storage like empty:
            if (savKeysExists <= 0) {
                this.productComparisonModelManager.storeEmptyNavigationTab(this.categoryName, this.navigationOrder);

                this.productComparisonModelManager.getModel().then(model => {
                    var hasProducts = model.products.length > 0;
                    if (hasProducts) {
                        this.productComparisonModelManager.setActiveNavigationTab(model.products[0].categoryName);
                    }
                });
            }

            // clear locked column info:
            if (this.deviceDetectionHelper.isMobileShop()) {
                this.productComparisonModelManager.clearLockedColumnIndex();
            }

            // refresh page with new url:
            location.replace(currentUrl);
        }

        private handleEmptyContainer(event: any): void {
            if(this.deviceDetectionHelper.isMobileShop()) {
                event.preventDefault();

                this.productComparisonModelManager.getModel().then(model => {
                    var hasProducts = model.products.length > 0;
                    if (!hasProducts) {
                        this.notificationService.notifyEmptyList();
                    } else {
                        window.location.href = this.emptyHeaderContainer.getAttribute('href');
                    }
                });
            }
        }
    }
}